import { TokenActions } from './actionTypes'
import { actionCreator } from './index'

export const updateToken = actionCreator<string>(TokenActions.UPDATE_TOKEN)
